<template>
  <div>
    <a class="ui red ribbon label">Экзамены</a>
    <table class="ui basic celled table">
      <thead>
      <tr class="active">
        <th v-for="column in t_head" :style="{width: column.width }"> {{ column.name }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="record in control.exam" :style="record.mark === 'Неудовлетворительно' || record.mark === 'Не явился' ? 'background-color:red' : 'background-color:none'">
        <td v-for="column in Object.keys(t_head)">{{ record[column] }}</td>
      </tr>
      </tbody>
    </table>

    <a class="ui blue ribbon label">Зачеты</a>
    <table class="ui basic celled table">
      <thead>
      <tr class="active">
        <th v-for="column in t_head" :style="{width: column.width }"> {{ column.name }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="record in control.test" :style="(record.mark === 'Не зачтено' || record.mark === 'Не явился') ? 'background-color:red' : 'background-color:none'">
        <td v-for="column in Object.keys(t_head)">{{ record[column] }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script >
  export default {
    name: "StudyYear",

    props: {
      control: Object,
    },
    data: () => ({
      t_head: {
        num: {name: '№', width: '2%'},
        name: {name: 'Дисциплина', width: '45%'},
        hours: {name: 'Часы', width: '10%'},
        mark: {name: 'Оценка', width: '8%'},
        date: {name: 'Дата сдачи', width: '10%'},
        teacher: {name: 'Преподаватель', width: '25%'}
      },
    }),
    methods: {}
  }
</script>